// ─────────────────────────────────────────────────────────────────────────────
// GENERATED FILE — DO NOT EDIT.
//
// Copied from shared/consent-ui/icons.jsx by shared/sync-consent-ui.js.
// Edit the original and re-run the sync; changes made here are overwritten and
// will silently un-share this component from the other NexusAI apps.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * The three icons the consent UI needs, inlined.
 *
 * Deliberately NOT imported from lucide-react. This package lives outside every
 * app's root, so a bare specifier here resolves against `shared/`, not the
 * consuming app's node_modules — and the build fails with "Rollup failed to
 * resolve import". Aliasing lucide-react in all three vite configs would fix
 * today's imports and break again the next time someone adds one.
 *
 * Keeping the dependency surface to React alone (which every app already
 * dedupes) makes the package genuinely portable. These are the lucide paths, so
 * they match the icons used elsewhere in the apps.
 */

const base = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

export function ShieldCheck({ size = 18, className = '' }) {
  return (
    <svg {...base(size)} className={className} aria-hidden="true">
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

export function Loader2({ size = 14, className = '' }) {
  return (
    <svg {...base(size)} className={className} aria-hidden="true">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
}

export function ExternalLink({ size = 10, className = '' }) {
  return (
    <svg {...base(size)} className={className} aria-hidden="true">
      <path d="M15 3h6v6" />
      <path d="M10 14 21 3" />
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    </svg>
  );
}

export function Download({ size = 14, className = '' }) {
  return (
    <svg {...base(size)} className={className} aria-hidden="true">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <path d="M7 10l5 5 5-5" />
      <path d="M12 15V3" />
    </svg>
  );
}

export function Trash2({ size = 14, className = '' }) {
  return (
    <svg {...base(size)} className={className} aria-hidden="true">
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  );
}
